import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';

export const NotFound: React.FC = () => {
  return (
    <div className="w-full overflow-hidden">
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-primary-600 to-secondary-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">
              404 - Page Not Found
            </h1>
            <p className="text-xl sm:text-2xl text-primary-100 max-w-3xl mx-auto leading-relaxed">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="mb-12">
            <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Search className="h-12 w-12 text-primary-600" />
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              We couldn't find that page
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              The page you requested could not be found. It might have been removed, renamed, or didn't exist in the first place.
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <Link to="/" className="btn-primary text-lg px-8 py-4 inline-flex items-center justify-center">
              <Home className="mr-2 h-5 w-5" />
              Back to Home
            </Link>
            <Link to="/contact" className="btn-outline text-lg px-8 py-4 inline-flex items-center justify-center">
              <ArrowLeft className="mr-2 h-5 w-5" />
              Contact Support
            </Link>
          </div>
        </div>
      </section>

      {/* Helpful Links */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            You might be looking for
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Link to="/services" className="card p-6 hover:shadow-lg transition-shadow">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Our Services</h3>
              <p className="text-gray-600">Explore our web design and development services</p>
            </Link>
            
            <Link to="/portfolio" className="card p-6 hover:shadow-lg transition-shadow">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Portfolio</h3>
              <p className="text-gray-600">View our recent projects and case studies</p>
            </Link>
            
            <Link to="/blog" className="card p-6 hover:shadow-lg transition-shadow">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Blog</h3>
              <p className="text-gray-600">Read our latest articles and insights</p>
            </Link>
            
            <Link to="/templates" className="card p-6 hover:shadow-lg transition-shadow">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Templates</h3>
              <p className="text-gray-600">Browse our website templates</p>
            </Link>
            
            <Link to="/get-started" className="card p-6 hover:shadow-lg transition-shadow">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Get Started</h3>
              <p className="text-gray-600">Begin your project with us</p>
            </Link>
            
            <Link to="/contact" className="card p-6 hover:shadow-lg transition-shadow">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Contact Us</h3>
              <p className="text-gray-600">Get in touch with our team</p>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary-600 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-6">
            Need Help Finding Something?
          </h2>
          <p className="text-xl text-primary-100 mb-8">
            Our team is here to assist you. Contact us and we'll help you find what you're looking for.
          </p>
          <Link to="/contact" className="btn-secondary text-lg px-8 py-4">
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  );
};